import rem from '@/utils/rem'

const SplitFileType = ({ text, maxWidth, ...splitFileTypeProps }) => {

	const styles = {
		maxWidth: rem(maxWidth)
	}

	return (
		<span className='split-file-type__content-file' style={styles} {...splitFileTypeProps}>
			<span className='split-file-type__content-file-name'>{text?.substring(0, text?.lastIndexOf('.'))}</span>
			<span className='split-file-type__content-file-extension'>.{text?.split(".")?.pop()}</span>
		</span>
	)
}

export default SplitFileType;
